// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__RkVCa","rotate":"Loading_rotate__AORkk","dash":"Loading_dash__jVVgC"};